module.exports = __webpack_public_path__ + "static/media/DuplicateSans-Thin.1ca21ff7.woff2";